import fetchApi from '../util/fetchApi';
import { JSONSchema } from '../util/jsonschemaTypes';
import { ApiEndpoint } from './ApiDefinition';
import checkErrors from './checkErrors';
import { JSONDateTime, JSONObject } from './types';

export type PagingResultDTO<T> = {
    from: number
    to: number
    count: number
    items: T[]
};

export type ObjectSchemaListItemDTO = {
    id: number
    name: string
    description: string
    conceptVectors: string
    workflows: string[]
    version: number
    lastUpdated: JSONDateTime
    removed: boolean
}

export type ObjectSchemaDTO = {
  id: number 
  name: string 
  description: string 
  conceptVectors: string 
  schema: JSONObject 
  metadataObjectMap: JSONObject 
  assignmentSlots: JSONObject 
  roleMap: JSONObject 
  tags?: JSONObject
  fwdRelations: UWEEntityTypeRelationDTO[]
  backRelations: UWEEntityTypeRelationDTO[]
  version: number
  lastUpdated: JSONDateTime
  removed: boolean
}

export enum UWEEntityRelationType {
  OneToOne=0,
  OneToMany=1,
};

export type UWEEntityTypeRelationDTO = {
  sourceId?: number
  sourceProperty: string
  targetId?: number
  targetProperty: string
  relationType: UWEEntityRelationType
  dataSchema: JSONObject
  metadataObjectMap: JSONObject
}

export type DiagramGraphDTO<T> = {
    adjacencyList: DiagramGraphNodeDTO<T>[]
    rootId?: number
}

export type DiagramGraphNodeDTO<T> = {
    data: T
    neighbors: DiagramGraphEdgeDTO[]
}

export type DiagramGraphEdgeDTO = {
    id: number
    label: string
}

export const ObjectSchemaApi = {
  list: ApiEndpoint<{
    offset?: number,
    size?: number,
    sortBy?: string,
    all?: boolean
  }, PagingResultDTO<ObjectSchemaListItemDTO>>({
    url: 'manage/objectschemas',
    query: ({ offset, size, sortBy, all }) => ({ offset, size, sortBy, all }),
  }),

  get: ApiEndpoint<{ objectSchemaId: number }, ObjectSchemaDTO>({
    url: ({ objectSchemaId }) => `manage/objectschemas/${objectSchemaId}`,
  }),

  getSchema: ApiEndpoint<{ objectSchemaId: number }, JSONSchema>({
    url: ({ objectSchemaId }) => `manage/objectschemas/${objectSchemaId}/schema`,
  }),

  update: ApiEndpoint<{objectSchemaId: number, schema: ObjectSchemaDTO}, ObjectSchemaDTO>({
    method: 'put',
    url: ({ objectSchemaId }) => `manage/objectschemas/${objectSchemaId}`,
    body: ({ schema }) => (schema),
  }),

  create: ApiEndpoint<ObjectSchemaDTO, ObjectSchemaDTO>({
    method: 'post',
    url: 'manage/objectschemas/',
    body: (schema) => schema,
  }),

  getDiagramAdjacencyList: ApiEndpoint<void, DiagramGraphDTO<ObjectSchemaListItemDTO>>({
    url: 'manage/objectschemas/diagram'
  }),
  deleteSchema: ApiEndpoint<{ id: number}, boolean>({
    method: 'delete',
    url: ({ id }) => `manage/objectschemas/${id}`
  }),
};

export default ObjectSchemaApi;
